import CUSTOM_CERT_TYPES from './_actionTypes';

const initialState = {
  uploading: false,
  uploadError: null,

  currentJob: null,
  currentJobLoading: false,
  currentJobError: null,

  jobs: [],
  jobsLoading: false,
  jobsError: null,
};

const customCertificatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_CERT_TYPES.UPLOAD_EXCEL_REQUEST:
      return { ...state, uploading: true, uploadError: null };
    case CUSTOM_CERT_TYPES.UPLOAD_EXCEL_SUCCESS:
      return {
        ...state,
        uploading: false,
        currentJob: action.payload,
        jobs: [action.payload, ...state.jobs],
      };
    case CUSTOM_CERT_TYPES.UPLOAD_EXCEL_FAILURE:
      return { ...state, uploading: false, uploadError: action.payload.error };

    case CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_REQUEST:
      return { ...state, currentJobLoading: true, currentJobError: null };
    case CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_SUCCESS:
      return {
        ...state,
        currentJobLoading: false,
        currentJob: action.payload,
        jobs: state.jobs.map((j) =>
          j.job_id === action.payload.job_id ? action.payload : j
        ),
      };
    case CUSTOM_CERT_TYPES.FETCH_JOB_STATUS_FAILURE:
      return { ...state, currentJobLoading: false, currentJobError: action.payload.error };

    case CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_REQUEST:
      return { ...state, jobsLoading: true, jobsError: null };
    case CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_SUCCESS:
      return { ...state, jobsLoading: false, jobs: action.payload };
    case CUSTOM_CERT_TYPES.FETCH_JOBS_LIST_FAILURE:
      return { ...state, jobsLoading: false, jobsError: action.payload.error };

    case CUSTOM_CERT_TYPES.CLEAR_CURRENT_JOB:
      return { ...state, currentJob: null, currentJobError: null, uploadError: null };

    default:
      return state;
  }
};

export default customCertificatesReducer;
